export enum CustomerSatisfactionType {
    VerySatisfied = "VerySatisfied",
    ExceededExpectations = "ExceededExpectations",
    Satisfied = "Satisfied",
    Dissatisfied = "Dissatisfied",
    VeryDissatisfied = "VeryDissatisfied",
    Archived = "Archived",
}
